import { z } from 'zod';

const getUrlHostname = (value: string) => {
  const withProtocol = /^[a-z][a-z\d+.-]*:\/\//i.test(value)
    ? value
    : `https://${value}`;

  try {
    return new URL(withProtocol).hostname.toLowerCase();
  } catch {
    return null;
  }
};

/**
 * Accepts URLs whose hostname is one of `hosts` or a subdomain of one
 * (e.g. `www.x.com`). Empty strings pass so optional fields can be cleared.
 * A value equal to `unchangedValue` (the saved value) also passes, so an
 * untouched field with legacy data never blocks the rest of the form.
 */
export const urlHostValidation = (
  hosts: string[],
  message: string,
  { unchangedValue }: { unchangedValue?: string | null } = {},
) =>
  z.string().refine(
    value => {
      if (value.length === 0) {
        return true;
      }

      if (unchangedValue !== undefined && value === unchangedValue) {
        return true;
      }

      const hostname = getUrlHostname(value.trim());

      return (
        hostname !== null &&
        hosts.some(host => hostname === host || hostname.endsWith(`.${host}`))
      );
    },
    { message },
  );
